import { stateName } from './constants';
// @ts-ignore This will always get set via react-on-rails
const initialState = {};

const railsContextReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return state;
};

export const plug = {
  [stateName]: railsContextReducer
};
export default railsContextReducer;